var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.302809 6.70591C0.0174239 6.42044 -0.0593421 6.0053 0.0725091 5.65007L0.174709 5.44857C0.211309 5.39312 0.254009 5.34052 0.302808 5.2917L0.302815 5.29169L0.304907 5.2896L2.42345 3.17038C2.81385 2.77985 3.44682 2.77986 3.83721 3.17038C4.22761 3.5609 4.22761 4.19407 3.83722 4.58459L3.42183 5.00011L9.06128 5.00012C9.61356 5.00012 10.0613 5.44783 10.0613 6.00012C10.0613 6.5524 9.61356 7.00012 9.06128 7.00012L3.42446 7.00011L3.83722 7.41301C4.22762 7.80353 4.22762 8.4367 3.83722 8.82722C3.44682 9.21775 2.81386 9.21775 2.42346 8.82722L0.306356 6.70944L0.302809 6.70591Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7184 11.2912C16.0038 11.5766 16.0806 11.9918 15.9487 12.347L15.8465 12.5485C15.8099 12.6039 15.7672 12.6566 15.7184 12.7054L15.7184 12.7054L15.7163 12.7075L13.5978 14.8267C13.2074 15.2172 12.5744 15.2172 12.184 14.8267C11.7936 14.4362 11.7936 13.803 12.184 13.4125L12.5994 12.997L6.95996 12.997C6.40768 12.997 5.95996 12.5492 5.95996 11.997C5.95996 11.4447 6.40768 10.997 6.95996 10.997L12.5968 10.997L12.184 10.5841C11.7936 10.1935 11.7936 9.56037 12.184 9.16985C12.5744 8.77932 13.2074 8.77932 13.5978 9.16985L15.7149 11.2876L15.7184 11.2912Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.fd64f56344ee6a70e89e153b43b59b77.svg";
export { ForwardRef as ReactComponent };